import { Controller } from "@hotwired/stimulus"
import Big from "big.js"

export default class ItemCostCalculatorController extends Controller {
  static values = { prices: Object }
  static targets = ["select", "quantity", "totalCost"]

  declare pricesValue: Record<string, string>
  declare selectTarget: HTMLSelectElement
  declare quantityTarget: HTMLInputElement
  declare totalCostTarget: HTMLInputElement

  calculate(): void {
    const selectedId = this.selectTarget.value
    const priceStr = this.pricesValue[selectedId]
    const qty = this.quantityTarget.value.trim()

    if (!selectedId || !priceStr || !qty) return

    try {
      const total = new Big(priceStr).times(qty)
      this.totalCostTarget.value = total.toFixed(2)
    } catch {
      // invalid input — leave total_cost unchanged
    }
  }
}
